import { useAppLoadingEvent } from "~/components/loading/hooks";
import { Loader, LoaderProps } from "~/ui";

export type AppLoaderProps = Omit<LoaderProps, "pos" | "color" | "size">;

/**
 * The core application loading indicator that appears in the top level of the application structure.
 */
export const AppLoader = (props: AppLoaderProps) => {
  const loading = useAppLoadingEvent();
  return loading ? <Loader {...props} size="md" /> : <></>;
};
